module.exports = __webpack_public_path__ + "img/info_banner1.b5056cc.jpg";